module.exports = __webpack_public_path__ + "img/empty_state_image.png";